const MAX_VISIBLE_LIST_ITEMS = 6;

const LIST_ITEM_HEIGHT = 48;
const SEPARATOR_HEIGHT = 1;

const LIST_ITEMS_HEIGHT = LIST_ITEM_HEIGHT * MAX_VISIBLE_LIST_ITEMS;
const SEPARATORS_HEIGHT = SEPARATOR_HEIGHT * MAX_VISIBLE_LIST_ITEMS - 1;

export const MAX_LIST_HEIGHT = LIST_ITEMS_HEIGHT + SEPARATORS_HEIGHT;
